// The monthly numbers on /safety (contract G1).
//
// GET /api/public/safety-stats answers { month, checks, humanReviews, reports,
// bans, removalsWithin48h, updatedAt }, counted since the first of the current
// UTC month and cached an hour. The page ships with "--" in every tile and
// "this month" as the month, so with this script blocked, or the endpoint
// down, it still reads correctly and promises nothing it cannot show. Only a
// number replaces a "--"; an error leaves the page as it was. ASCII only.

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function monthName(ym) {
  const m = /^(\d{4})-(\d{2})$/.exec(String(ym || ''));
  if (!m) return null;
  const name = MONTHS[Number(m[2]) - 1];
  return name ? `${name} ${m[1]}` : null;
}

fetch('/api/public/safety-stats', { headers: { Accept: 'application/json' } })
  .then((r) => (r.ok ? r.json() : null))
  .then((stats) => {
    if (!stats || typeof stats !== 'object') return;
    for (const el of document.querySelectorAll('[data-stat]')) {
      const value = stats[el.dataset.stat];
      if (typeof value === 'number' && Number.isFinite(value)) el.textContent = value.toLocaleString('en-US');
    }
    const month = monthName(stats.month);
    const monthEl = document.querySelector('[data-stat-month]');
    if (monthEl && month) monthEl.textContent = month;
  })
  .catch(() => {
    // The "--" placeholders stand. They say exactly what is known: nothing yet.
  });
